"use strict";

var _classCallCheck = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var match_1 = __importDefault(require("../match"));
var Ascii = /*#__PURE__*/function () {
  function Ascii() {
    _classCallCheck(this, Ascii);
  }
  _createClass(Ascii, [{
    key: "name",
    value: function name() {
      return 'ASCII';
    }
  }, {
    key: "match",
    value: function match(det) {
      var input = det.rawInput;
      for (var i = 0; i < det.rawLen; i++) {
        var b = input[i];
        if (b < 32 || b > 126) {
          return (0, match_1.default)(det, this, 0);
        }
      }
      return (0, match_1.default)(det, this, 100);
    }
  }]);
  return Ascii;
}();
exports.default = Ascii;